import { useMemo } from 'react'
import { useCurrentAccountContext } from '@retailer-platform/dashboard/utils'
import { Permission } from '../../access-control/permissions.ts'

const samaPermissions: string[] = [
  Permission.QualityAuditSamaModifyAccess,
  Permission.QualityAuditSamaViewAccess,
  Permission.QualityAuditSamaModifyAssigneeAccess,
  Permission.QualityAuditSamaModifyReviewerAccess,
]

const icPermissions: string[] = [
  Permission.QualityAuditViewAccess,
  Permission.QualityAuditModifyAccess,
  Permission.QualityAuditManagerViewAccess,
  Permission.QualityAuditManagerModifyAccess,
]

const eyPermissions: string[] = [
  Permission.QualityAuditEyViewAccess,
  Permission.QualityAuditEyModifyAccess,
  Permission.QualityAuditEyModifyAssigneeAccess,
  Permission.QualityAuditEyModifyReviewerAccess,
]

const kpmgPermissions: string[] = [
  Permission.QualityAuditKpmgViewAccess,
  Permission.QualityAuditKpmgModifyAccess,
  Permission.QualityAuditKpmgModifyAssigneeAccess,
  Permission.QualityAuditKpmgModifyReviewerAccess,
]

export const enum OutsourceVendor {
  sama = 'sama',
  ic_admin = 'ic_admin',
  ey = 'ey',
  kpmg = 'kpmg',
}

export const useOutsourceVendor = () => {
  const currentAccount = useCurrentAccountContext()

  const outsourceVendor: string | undefined = useMemo(() => {
    const permissions = currentAccount?.account?.permissions ?? []
    const hasSamaPermission =
      permissions.filter(permission => samaPermissions.includes(permission?.slug ?? '')).length > 0
    const hasIcPermission =
      permissions.filter(permission => icPermissions.includes(permission?.slug ?? '')).length > 0
    const hasEyPermission =
      permissions.filter(permission => eyPermissions.includes(permission?.slug ?? '')).length > 0
    const hasKpmgPermission =
      permissions.filter(permission => kpmgPermissions.includes(permission?.slug ?? '')).length > 0

    if (hasIcPermission) {
      return OutsourceVendor.ic_admin
    } else if (hasSamaPermission) {
      return OutsourceVendor.sama
    } else if (hasEyPermission) {
      return OutsourceVendor.ey
    } else if (hasKpmgPermission) {
      return OutsourceVendor.kpmg
    } else {
      return ''
    }
  }, [currentAccount])

  return outsourceVendor
}
